<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="name"
      option-value="id"
      :emit-value="emitValue"
      map-options
      hint=""
      :use-chips="multiple"
      :multiple="multiple"
      :loading="organizationsLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
    >
      <template v-slot:option="scope">
        <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
          <q-item-section>
            <q-item-label>
              {{ scope.opt.name }}
              <span style="font-size: 10px">
                ({{
                  currentUserData.role == "superAdmin"
                    ? scope.opt.applications_name
                    : ""
                }})
              </span>
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    id: {
      default: null
    },
    label: {
      type: String,
      default: "Assign Organization"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    emitValue: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      organizations: "organizations/list",
      organizationsLoading: "organizations/listLoading"
    })
  },
  watch: {
    id: function() {
      this.init();
    },
    organizations: function() {
      this.init();
    }
  },
  data: () => ({
    model: null,
    options: []
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.options = JSON.parse(JSON.stringify(this.organizations));
      let idList = null;
      if (this.multiple && this.id) {
        idList = this.id.split(",").map(function(x) {
          return parseInt(x, 10);
        });
      } else {
        idList = this.id;
      }
      this.model = idList;
    },
    filterFn(val, update) {
      if (val === "") {
        update(() => {
          this.options = JSON.parse(JSON.stringify(this.organizations));
        });
        return;
      } else {
        update(() => {
          const needle = val.toLowerCase();
          this.options = this.organizations.filter(
            v => v.name.toLowerCase().indexOf(needle) > -1
          );
        });
      }
    }
  }
};
</script>
